export function formatDate(dateStr: string | number | Date, options?: Intl.DateTimeFormatOptions) {
  if (dateStr == null) {
    return 'Undecided'
  }
  const date = new Date(dateStr)
  return date.toLocaleDateString(undefined, options)
}

export const relativeDate = (date: Date, short: boolean): string => {
  const now = new Date(Date.now())
  const diffTime = now.getTime() - date.getTime()
  const diffDays = Math.floor(diffTime / (1000 * 3600 * 24))
  if (diffDays == 1) return `1${short ? 'd' : ' day'} ago`
  if (diffDays > 1) {
    return `${diffDays}${short ? 'd' : ' days'} ago`
  }
  const hours = Math.floor(diffTime / (1000 * 3600))
  if (hours == 0) return 'now'
  if (hours == 1) return `1${short ? 'h' : ' hour'} ago`
  return `${hours}${short ? 'h' : ' hours'} ago`
}

export function dateToISO(d: string | number | Date): string {
  try {
    const date = new Date(d)
    return date.toISOString()
  } catch {
    console.error('dateToISO() failed', d)
    return ''
  }
}

export function timestamp(seconds: Date | number): Date {
  if (typeof seconds === 'number') {
    return new Date(seconds * 1000)
  }
  return seconds
}

export function formatDateTime(
  dateStr: string | number | Date,
  options?: Intl.DateTimeFormatOptions,
) {
  if (dateStr == null) {
    return 'N/A'
  }

  try {
    const date = new Date(dateStr)
    return date.toLocaleString(undefined, options ?? {})
  } catch (err) {
    console.error(err)
    return 'N/A'
  }
}
